import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Wordmark from "../Brand/Wordmark";
import { ArrowIcon, MenuIcon } from "../Brand/Icons";
import { CONTACT, NAV_LINKS } from "./nav";
import "./layout.css";

const SiteHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  // Close the mobile menu whenever the route changes.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  // Close the mobile menu on Escape.
  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setMenuOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  return (
    <header className="is-header">
      <div className="is-header__bar">
        <Link to="/" className="is-header__brand" aria-label="Infinitude Stack — home">
          <Wordmark />
        </Link>

        <nav aria-label="Main" className="is-header__links">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                "is-header__link" + (isActive ? " is-header__link--active" : "")
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="is-header__actions">
          <a href={CONTACT.phoneHref} className="is-header__phone">
            {CONTACT.phoneDisplay}
          </a>
          <Link to="/contact" className="is-btn is-btn--primary is-btn--sm is-header__cta">
            Start a project
            <span className="is-btn__arrow">
              <ArrowIcon />
            </span>
          </Link>
          <button
            type="button"
            className="is-header__burger"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
            aria-controls="is-mobile-menu"
            onClick={() => setMenuOpen((open) => !open)}
          >
            <MenuIcon open={menuOpen} />
          </button>
        </div>

        {menuOpen && (
          <div id="is-mobile-menu" className="is-header__menu">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  "is-header__menu-link" +
                  (isActive ? " is-header__menu-link--active" : "")
                }
              >
                {link.label}
              </NavLink>
            ))}
            <a href={CONTACT.phoneHref} className="is-header__menu-link">
              Call {CONTACT.phoneDisplay}
            </a>
            <Link
              to="/contact"
              className="is-btn is-btn--primary is-btn--block is-header__menu-cta"
            >
              Start a project →
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default SiteHeader;
